module.exports = __webpack_public_path__ + "assets/report_bug.7c4bbad9.svg";